import React from 'react'
import BodySection from '../../Components/Body/BodySection'
import BodySettingsLayout from '../../Layouts/BodySettingsLayout'
import TwoFactorBlock from './TwoFactorBlock/TwoFactorBlock'

export default function SettingsSecurityMain() {
  return (
    <BodySettingsLayout>
      <BodySection title="התחברות">
        <TwoFactorBlock />
      </BodySection>
    </BodySettingsLayout>
  )
}
